import { FontFamily } from '@euler/components/typography/fonts';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import React, { memo, useMemo } from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { useTheme } from 'styled-components/native';
import { SuggestedQuestionsPayload } from './payloads';

export const SuggestedQuestionsWidget = memo(
  ({
    data,
    onPress,
  }: {
    data: SuggestedQuestionsPayload;
    onPress?: (text: string) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const theme = useTheme();
    const s = useMemo(
      () =>
        StyleSheet.create({
          suggestionChip: {
            borderWidth: 1,
            borderRadius: rpx(16),
            paddingHorizontal: rpx(14),
            paddingVertical: rpx(8),
            marginBottom: rpx(6),
          },
          suggestionText: {
            fontSize: rpx(13),
            fontFamily: FontFamily.NotoSans.Regular,
          },
        }),
      [rpx],
    );

    const questions: string[] = Array.isArray(data) ? data : [];

    return (
      <View style={{ marginTop: rpx(4) }}>
        {questions.map((q, i) => (
          <TouchableOpacity
            key={i}
            activeOpacity={0.7}
            onPress={() => onPress?.(q)}
            style={[s.suggestionChip, { borderColor: theme.link + '40' }]}
          >
            <Text style={[s.suggestionText, { color: theme.link }]}>{q}</Text>
          </TouchableOpacity>
        ))}
      </View>
    );
  },
);
